{ "bip122:000000000000000000651ef99cb9fcbe/slip44:145": "bitcoin-cash" }
